import { Deserializable } from './deserializable.model';

export class TokenResponse implements Deserializable<any, TokenResponse> {
  tokenId: string;
  token: string;
  tokenType: string;
  groupId: string;
  userId: string;

  deserialize(input: any): TokenResponse {
    if (input == null) {
      return null;
    }
    this.tokenId = input.id;
    this.token = input.token;
    this.tokenType = input.tokenType;
    this.groupId = input.groupId;
    this.userId = input.userId;
    return this;
  }
}
